module.exports = __webpack_public_path__ + "img/btn_添加.0f280784.svg";